import React, { useState, Fragment, useRef } from "react";
import { withRouter } from "react-router";

import {
  Row,
  Col,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
} from "reactstrap";
import Pagination from "../../common/Pagination";
import {

  PopUpEmployeeMouseOver,

} from "../../../components/employee/index";
const EmployeeCard = React.memo((props) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [postPerPage] = useState(10);
  const [isOpenRadioButton, setIsOpenRadioButton] = useState(false);
  const setDropdownOpt = useRef(0); // to not to open othe dropdown opt, when 3dots clicked

  const toggle = React.useCallback(
    (whichCard) => {
      setDropdownOpen((prevState) => !prevState);
      setDropdownOpt.current = whichCard;
    },
    [setDropdownOpen]
  );

  const handlePageClick = React.useCallback(
    (pageNumber) => {
      setCurrentPage(pageNumber);
    },
    [setCurrentPage]
  );

  // current post.
  const indexOfLastPost = currentPage * postPerPage;
  const indexOfFirstPost = indexOfLastPost - postPerPage;
  const currentPost = props.allEmpList.slice(indexOfFirstPost, indexOfLastPost);
  // console.log("currentPost",currentPost)
  return (
    <Fragment>
      <Row>
        <Col>
          <h3>Employee</h3>
        </Col>
        {/* <Col>
                <Input
                  type="text"
                  className="d-inline"
                  placeholder="Search Employee...."
                  onChange={(e) => props.searchEmployee(e.target.value)}
                />
              </Col> */}
      </Row>

      <Row>
        <Col md={3} sm={3}
        // onMouseLeave={props.handlemouseleave}
        >
          <div
            className="profile-widget"
            style={{ height: "86%" }}

          >
            <div className="profile-img">
              <i className="fas fa-plus fa-3x"  onMouseEnter={props.handlemouseenter}></i>
            </div>
          </div>
        </Col>
        {/* List all the employees in card view */}
        {currentPost.map((emp, i) => {
          return (

            <Col md={3} sm={3} key={i}>

              <div className="profile-widget">
                <div className="profile-img">
                  <a href={`/empProfile/`+emp.value.employeeId}>
                    <img
                      width="100%"
                      // src={require(`../../../img/employee/user.png`)}
                      src={emp.value.profilePicture == null || emp.value.profilePicture == "null" || emp.value.profilePicture=='undefined'? (require(`../../../img/employee/user.png`)) : (`https://niraconnect.nirasystems.com:8080/wwwroot/UploadedPhotos/ProfilePicture/${emp.value.profilePicture}`)}
                      alt="Card cap"
                    />
                  </a>
                </div>
                <div className="dropdown profile-action text-muted">
                  <Dropdown
                    isOpen={setDropdownOpt.current === i ? dropdownOpen : false}
                    toggle={() => toggle(i)}
                  >
                    <DropdownToggle color="">
                      <i className="fas fa-ellipsis-v"></i>
                    </DropdownToggle>
                    <DropdownMenu
                      right
                      modifiers={{
                        setMinWidth: {
                          enabled: true,
                          order: 890,
                          fn: (data) => {
                            return {
                              ...data,
                              styles: {
                                ...data.styles,
                                minWidth: "100px",
                              },
                            };
                          },
                        },
                      }}
                    >
                      <DropdownItem
                        onClick={() => props.handleOnclickEdit(emp.value)}
                      >
                        Edit
                      </DropdownItem>
                      <DropdownItem
                        onClick={() =>
                          props.handleOnclickDelete(emp.value.employeeId)
                        }
                      >
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div>
                <a href={`/empProfile`}>
                 <h4 className="user-name m-t-10 mb-0">
  <span className="text-ellipsis" style={{fontWeight:"500"}}>{emp.value.employeeName}</span>
  {!emp.value.isActive && (
    <span style={{ color: "red", marginLeft: "4px" }}>(Resigned)</span>
  )}
</h4>

                  <div className="small text-muted">
                    {emp.value.designationName} ({emp.value.employeeCode})
                  </div>
                </a>
              </div>
            </Col>
          );
        })}
      </Row>
      <Pagination
        totalPost={props.allEmpList.length}
        postPerPage={postPerPage}
        currentPage={currentPage}
        handlePageClick={handlePageClick}
      />

    </Fragment>
  );
});

export default withRouter(EmployeeCard);
